module.exports = __webpack_public_path__ + "media/signup-react/pin-ba03d630.svg";